import { FC } from "react";
import { COLORS } from "shared/consts";

type Props = {
    fill?: string;
};

export const Apiary: FC<Props> = ({ fill = COLORS.FG.MUTED }) => (
    <svg
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
    >
        <rect width="16" height="16" x="0" y="0" fill="none" />
        <path
            d="M11 1.50004C11 1.40799 10.9254 1.33337 10.8333 1.33337L1.83334 1.33337C1.74129 1.33337 1.66667 1.40799 1.66667 1.50004L1.66667 4.16671C1.66667 4.25875 1.74129 4.33337 1.83334 4.33337L2.33334 4.33337L2.33334 8.00004C2.33334 8.73642 2.93029 9.33337 3.66667 9.33337L3.66667 8.33337C3.48258 8.33337 3.33334 8.18414 3.33334 8.00004L3.33334 4.33337L9.33334 4.33337L9.33334 5.33337L10.3333 5.33337L10.3333 4.33337L10.8333 4.33337C10.9254 4.33337 11 4.25875 11 4.16671L11 1.50004ZM10 3.33337L2.66667 3.33337L2.66667 2.33337L10 2.33337L10 3.33337ZM14.1667 6.66671C14.2587 6.66671 14.3333 6.74133 14.3333 6.83337L14.3333 9.50004C14.3333 9.59209 14.2587 9.66671 14.1667 9.66671L13.6667 9.66671L13.6667 13.3334C13.6667 14.0698 13.0697 14.6667 12.3333 14.6667L7 14.6667C6.26363 14.6667 5.66667 14.0698 5.66667 13.3334L5.66667 9.66671L5.16667 9.66671C5.07462 9.66671 5 9.59209 5 9.50004L5 6.83337C5 6.74133 5.07462 6.66671 5.16667 6.66671L14.1667 6.66671ZM6 8.66671L13.3333 8.66671L13.3333 7.66671L6 7.66671L6 8.66671ZM6.66667 13.3334C6.66667 13.5175 6.81591 13.6667 7 13.6667L12.3333 13.6667C12.5174 13.6667 12.6667 13.5175 12.6667 13.3334L12.6667 9.66671L6.66667 9.66671L6.66667 13.3334ZM10.5 10.3334C10.7761 10.3334 11 10.5572 11 10.8334C11 11.1095 10.7761 11.3334 10.5 11.3334L8.83334 11.3334C8.5572 11.3334 8.33334 11.1095 8.33334 10.8334C8.33334 10.5572 8.5572 10.3334 8.83334 10.3334L10.5 10.3334Z"
            fill={fill}
            fillRule="evenodd"
        />
    </svg>
);
